/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import i18next from 'I18n'
import { Menu, Popover } from 'antd'
import { useTranslation } from 'react-i18next'

import { EN_ICON, HAMBURGER_MENU, JP_ICON, USER_ICON, VI_ICON, WHITE_HISERRIES_ICON } from 'Assets'
import { useAuth, useRoot } from 'Hooks'
import { Link, useHistory } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import ButtonLink from '../button/button-link'

const Wrapper = styled.header`
  padding: 0 81px;
  width: 100%;
  height: 63px;
  background-color: ${({ theme }) => theme.primary};
  position: fixed;
  z-index: 1000;

  .ant-popover.ant-popover-placement-bottom {
    position : fixed;
  }

  .user-avatar {
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translate(0, -50%);
    cursor: pointer;
  }

  .toggle-menu {
    position: absolute;
    top: 50%;
    left: 13px;
    transform: translate(0, -50%);

    button {
      display: flex;
      background: transparent;
      border: none;
      outline: none;
    }
  }

  .container {
    height: 63px;
    width: 100%;

    .row {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .header-left {
        flex: 1 0;

        .search {
          display: flex;
          align-items: center;

          label.cursor-pointer {
            cursor: pointer;

            svg.svg-icon--material {
              font-size: 1.5rem;
              fill: #6c5ed3;
            }
          }

          input.search-input {
            border: none;
            background-color: transparent;
            width: 100%;
            font-weight: 500;
            padding: .3rem .75rem;

            &:focus-visible {
              outline: none;
            }
          }
        }

        .logo {
          width: 150px;
        }
      }

      .header-right {
        flex: 0 0 auto;
        width: auto;

        .row {
          flex-wrap: wrap;

          .col-auto {
            margin: .5rem;

            button {
              cursor: pointer;
            }
          }

          .btn-action {
            padding: .625rem;
            width: calc(28px + 1.25rem);
            height: calc(28px + 1.25rem);
            background-color: transparent;
            border: none;
            border-radius: 1.25rem;

            &:hover, &:active {
              background-color: #e7eef8;
              border-color: #e7eef8;
            }
          }

          .user-info {
            cursor: pointer;
            display: flex;
            align-items: center;

            .text-end {
              text-align: end;
              margin-right: .7rem;

              .name {
                font-weight: 600;
                font-size: .75rem;
                color: #808191;
              }

              .title {
                font-weight: 300;
                font-size: .75rem;
                color: #6c757d;
              }
            }

            .avatar {
              background-color: #fff3d4;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
`

const Header = () => {
  const { t, i18n: { language } } = useTranslation(['menu'])
  const { authenticated, logOutAction } = useAuth()
  const history = useHistory()
  const { toggleSidebarAction } = useRoot()
  const { instance } = useMsal()
  const [visible, setVisible] = useState(false)

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible)
  }

  const languageIcon = useMemo(() => {
    switch (language) {
      case 'en':
        return <EN_ICON />
      case 'jp':
        return <JP_ICON />
      case 'vi':
        return <VI_ICON />
      default:
        return null
    }
  }, [language])

  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={() => i18next.changeLanguage('en')}>
        <EN_ICON />
        <span>&nbsp;English</span>
      </Menu.Item>
      <Menu.Item key="1" onClick={() => i18next.changeLanguage('jp')}>
        <JP_ICON />
        <span>&nbsp;日本語</span>
      </Menu.Item>
      <Menu.Item key="2" onClick={() => i18next.changeLanguage('vi')}>
        <VI_ICON />
        <span>&nbsp;Tiếng Việt</span>
      </Menu.Item>
    </Menu>
  )

  function handleClick(clickType) {
    switch (clickType) {
      case 'account_info':
        history.push('/account-info')
        break
      case '2fa_setting':
        history.push('/2fa')
        break
      case 'log_out':
        toggleSidebarAction(false)
        logOutAction()
        history.push('/logout')
        break
      default:
        break
    }
  }

  return (
    <Wrapper>
      <div className="container">
        <div className="row">
          {
            authenticated && (
              <div className="toggle-menu">
                <button style={{ cursor: 'pointer' }} onClick={() => toggleSidebarAction()}>
                  <HAMBURGER_MENU />
                </button>
              </div>
            )
          }
          <Link to="/" style={{ width: '197px', height: '28px', marginTop: '-60px' }}>
            <WHITE_HISERRIES_ICON />
          </Link>

          {
            authenticated && (
              <div className="user-avatar" id="user-avatar">
                <Popover
                  content={(
                    <div className="popover-content">
                      {/* <p><ButtonLink onClick={() => handleClick('account_info')}>{t('account_info')}</ButtonLink></p>
                      <p><ButtonLink onClick={() => handleClick('2fa_setting')}>{t('2fa_setting')}</ButtonLink></p> */}
                      <p><ButtonLink onClick={() => handleClick('log_out')}>{t('log_out')}</ButtonLink></p>
                    </div>
                  )}
                  trigger="click"
                  visible={visible}
                  onVisibleChange={handleVisibleChange}
                  getPopupContainer={() => document.getElementById('user-avatar')}
                >
                  <div><USER_ICON /></div>
                </Popover>
              </div>
            )
          }
        </div>
      </div>
    </Wrapper>
  )
}

export default Header
